import * as L from 'leaflet';
import { l2a, loc_equal } from 'shared/map/lib/utils';
import { createElementHook, createElementObject, useLeafletContext, } from '@react-leaflet/core';
import { useEffect, useRef } from 'react';
function createSimpleMarker(props, context) {
    const marker = L.marker(props.position, {
        zIndexOffset: props.zIndexOffset != null ? props.zIndexOffset : 0,
        ...props,
    });
    if (props.onClick) {
        marker.on('click', (e) => props.onClick?.(e));
    }
    if (props.onGetCoord) {
        marker.on('click', () => props.onGetCoord?.(l2a(marker.getLatLng())));
    }
    if (props.onMoveEnd) {
        marker.on('moveend', (e) => props.onMoveEnd?.(e));
    }
    if (props.onMove) {
        marker.on('move', (e) => props.onMove?.(marker.getLatLng()));
    }
    return createElementObject(marker, context);
}
function updateSimpleMarker(instance, props, prevProps) {
    if (!loc_equal(prevProps.position, props.position)) {
        instance.setLatLng(props.position);
    }
}
const useSimpleMarkerElement = createElementHook(createSimpleMarker, updateSimpleMarker);
export const SimpleMarker = (props) => {
    const context = useLeafletContext();
    const markerRef = useSimpleMarkerElement(props, context);
    const iconRef = useRef();
    const propsRef = useRef(props);
    useEffect(() => {
        const icon = L.divIcon({
            className: props.icon_class,
            iconSize: [props.icon_width, props.icon_height],
            iconAnchor: props.icon_anchor != null
                ? props.icon_anchor
                : [props.icon_width / 2, props.icon_height / 2],
        });
        iconRef.current = icon;
        markerRef.current.instance.setIcon(icon);
        const container = context.layerContainer || context.map;
        container.addLayer(markerRef.current.instance);
        return () => {
            container.removeLayer(markerRef.current.instance);
        };
    }, []);
    useEffect(() => {
        if (propsRef.current.icon_class !== props.icon_class) {
            if (iconRef.current) {
                iconRef.current.options.className = props.icon_class;
            }
        }
        if (propsRef.current.icon_width !== props.icon_width ||
            propsRef.current.icon_height !== props.icon_height ||
            (propsRef.current.icon_anchor == null && props.icon_anchor) ||
            (propsRef.current.icon_anchor && props.icon_anchor == null) ||
            (propsRef.current.icon_anchor &&
                props.icon_anchor &&
                !loc_equal(propsRef.current.icon_anchor, props.icon_anchor))) {
            if (iconRef.current) {
                iconRef.current.options.iconSize = [
                    props.icon_width,
                    props.icon_height,
                ];
                iconRef.current.options.iconAnchor =
                    props.icon_anchor != null
                        ? props.icon_anchor
                        : [props.icon_width / 2, props.icon_height / 2];
                markerRef.current.instance.setIcon(iconRef.current);
            }
        }
        propsRef.current = props;
    }, [props]);
    return null;
};
